import React, { useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { KeyRound } from "lucide-react";
import PasswordInput from "@/components/PasswordInput";

export default function ConsultantSetPasswordPage() {
  const [cur, setCur] = useState("");
  const [next, setNext] = useState("");
  const [again, setAgain] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (next !== again) { setError("The two new passwords do not match"); return; }
    if (next.length < 10) { setError("Choose a password of at least 10 characters"); return; }
    setBusy(true);
    try {
      await api.post("/consultant/change-password",
        { current_password: cur, new_password: next });
      toast.success("Password updated");
      window.location.href = "/consultant";
    } catch (err) { setError(formatApiError(err)); }
    finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-zinc-50 flex items-center justify-center px-6">
      <Card className="w-full max-w-md border-zinc-200 shadow-none">
        <CardHeader className="pb-2">
          <CardTitle className="flex items-center gap-2 text-base font-semibold">
            <KeyRound className="h-4 w-4 text-emerald-600" /> Choose your own password
          </CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-sm text-zinc-600">
            You are signed in with a password Arborvitae issued. Please replace it with
            one only you know before continuing.
          </p>
          {error ? (
            <div className="mt-4 rounded-md border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700"
              data-testid="con-setpw-error">{error}</div>
          ) : null}
          <form onSubmit={submit} className="mt-4 space-y-4">
            <div>
              <Label className="text-xs text-zinc-500">Password you were given</Label>
              <PasswordInput value={cur} onChange={(e) => setCur(e.target.value)}
                className="h-10" data-testid="con-setpw-current" required />
            </div>
            <div>
              <Label className="text-xs text-zinc-500">New password (at least 10 characters)</Label>
              <PasswordInput value={next} onChange={(e) => setNext(e.target.value)}
                className="h-10" data-testid="con-setpw-new" required />
            </div>
            <div>
              <Label className="text-xs text-zinc-500">New password again</Label>
              <PasswordInput value={again} onChange={(e) => setAgain(e.target.value)}
                className="h-10" data-testid="con-setpw-again" required />
            </div>
            <Button type="submit" disabled={busy} className="w-full h-10"
              data-testid="con-setpw-submit">
              {busy ? "Saving…" : "Set password"}
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
